import { createI18nProperty } from '@/i18n'
import Index from './index.vue'
import blankLayout from '../layout/blankLayout.vue'
import { TAB_CATEGORY } from '@/constant/permission'

const basePath = '/v-admin/chatbot-management'

export default {
  name: 'chatBotManagementLayout',
  path: `${basePath}`,
  component: blankLayout,
  redirect: `${basePath}/index`,
  meta: {
    isInclude: true,
    permission: TAB_CATEGORY.CHAT_BOT,
    rootLayout: {
      autosize: true
    },
    titleI18nKey: 'admin.chatBot.title',
    tab: createI18nProperty({
      contentStyle: {
        background: '#f7f7f7',
        padding: '40px'
      }
    }, 'label', 'admin.chatBot.tab')
  },
  children: [
    {
      name: 'chatBotManagementIndex',
      path: `${basePath}/index`,
      component: Index,
      meta: {
        titleI18nKey: 'admin.chatBot.tab'
      }
    }
  ]
}
